import { Switch, Button } from "antd";
import type { ColumnsType } from "antd/es/table";
import { langPage, langTableColumns, langCommon } from "../../../locales";
import { CardServer } from "../../../server";
import { FormConfigType } from "../../../components/editForm";

const server = CardServer.Product
const lang = langPage?.card;

export const generateTableColumns = (props: any): ColumnsType => {
    const { setLoading, refresh, operationRef } = props;
    return [
        {
            title: lang?.udpayCardBin,
            dataIndex: "UdpayCardBin",
        },
        {
            title: lang?.udpayCardScheme,
            dataIndex: "UdpayCardScheme",
        },
        {
            title: lang?.udpayModeType,
            dataIndex: "UdpayModeType",
        },
        {
            title: lang?.udpayProductId,
            dataIndex: "UdpayProductId",
        },
        {
            title: lang?.udpayProductStatus,
            dataIndex: "UdpayProductStatus",
        },
        {
            title: langCommon?.sort,
            dataIndex: "Sort",
        },
        {
            title: langCommon?.status,
            dataIndex: "Status",
            render: (_: any, row: any) => {
                return <Switch
                    checkedChildren={lang?.product.status1}
                    unCheckedChildren={lang?.product.status2}
                    checked={row.Status === 1}
                    onChange={async (checked) => {
                        setLoading(true);
                        try {
                            const { Id } = row;
                            await server.enabled({ Id, Status: checked })
                            refresh?.();
                        } catch (error) {
                        }
                        setLoading(false);
                    }}
                />;
            }
        },
        {
            title: '备注',
            dataIndex: "Remark",
        },
        {
            title: langTableColumns?.CreatedAtString,
            dataIndex: "CreatedAtString",
        },
        {
            title: langTableColumns?.operation,
            dataIndex: "ops",
            width: 80,
            fixed: "right",
            render: (_: any, row: any) => {
                return (
                    <div>
                        <Button size="small" type="link"
                            onClick={() => operationRef?.current?.changeVisible(row, 'update')}
                        >{langCommon?.modify}</Button>
                    </div>
                )
            }
        }
    ]
}


export const DEFAULT_OPERATION_DATA = {
    Remark: null,
    Id: null,
}

export const generateOperationFormConfig = (props: any): FormConfigType => {
    return [
        {
            title: '备注',
            type: "input",
            extendType: "TextArea",
            field: "Remark",
        },
    ];
}
